module.exports = __webpack_public_path__ + "img/group.d16582d2.svg";